import React from 'react';
import { PhoneIcon, HomeIcon, ClockIcon } from './icons';
export function Footer() {
  return <footer className="bg-black pt-20 pb-10 border-t-4 border-brand-gold" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-85">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/r65Do7snHotGvJ9xDGDVi3/heylloyd-image-1774744993354.png" alt="Benitez Handyman Construction Logo" className="h-32 w-auto object-contain rounded mb-6" data-id="element-87" />
            <p className="text-xl text-gray-400 font-medium max-w-md" data-id="element-88">
              Trabajo hecho con orgullo, por alguien que da la cara.
            </p>
          </div>

          {/* Contact Column */}
          <div data-id="element-89">
            <h4 className="text-2xl font-heading font-bold text-white mb-6 uppercase tracking-wider" data-id="element-90">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-91">
              <li data-id="element-92">
                <a href="tel:2029132653" className="flex items-center gap-3 text-lg text-brand-gold hover:text-brand-gold-light transition-colors group" data-id="element-93">
                  <div className="bg-brand-gold/10 p-2 rounded-full group-hover:bg-brand-gold/20 transition-colors" data-id="element-94">
                    <PhoneIcon className="w-5 h-5" data-id="element-95" />
                  </div>
                  <span className="font-bold tracking-wide" data-id="element-96">
                    (202) 913-2653
                  </span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-97">
                <div className="bg-gray-800 p-2 rounded-full mt-1" data-id="element-98">
                  <HomeIcon className="w-5 h-5 text-gray-300" data-id="element-99" />
                </div>
                <div data-id="element-100">
                  <p className="font-medium text-white mb-1" data-id="element-101">
                    Área de Servicio:
                  </p>
                  <p data-id="element-102">MD | DC | VA</p>
                  <p className="text-sm mt-1" data-id="element-103">
                    Base: New Carrollton / Hyattsville
                  </p>
                </div>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-104">
                <div className="bg-gray-800 p-2 rounded-full" data-id="element-105">
                  <ClockIcon className="w-5 h-5 text-gray-300" data-id="element-106" />
                </div>
                <span className="font-medium text-white" data-id="element-107">
                  Disponibilidad: <span className="text-brand-gold" data-id="element-108">24/7</span>
                </span>
              </li>
            </ul>
          </div>

          {/* Quick Links / Info */}
          <div data-id="element-109">
            <h4 className="text-2xl font-heading font-bold text-white mb-6 uppercase tracking-wider" data-id="element-110">
              Servicios
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-111">
              <li data-id="element-112">Remodelación Completa</li>
              <li data-id="element-113">Restauración Estructural</li>
              <li data-id="element-114">Fences & Roofing</li>
              <li data-id="element-115">Masonry & Concreto</li>
              <li data-id="element-116">Pintura & Drywall</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-117">
          <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-118">
            &copy; {new Date().getFullYear()} BENITEZ HANDYMAN CONSTRUCTION.
            Todos los derechos reservados.
          </p>
          <div className="flex gap-4" data-id="element-119">
            <span className="text-brand-gold text-sm font-heading tracking-widest uppercase" data-id="element-120">
              MD • DC • VA
            </span>
          </div>
        </div>
      </div>
    </footer>;
}